import { ComplaintEntity, ComplaintSchema } from 'mk2/containers/Complaint/Complaint.schemas';
import { AppState } from 'mk2/reducers';
import { EntitiesState } from 'mk2/reducers/entities';
import { createDenormalizedEntitiesSelector } from 'mk2/selectors';

const getDenormalizedComplaints = createDenormalizedEntitiesSelector<ComplaintEntity>();
export const getComplaintsComplaints = (state: AppState, entity: string, id: number) => {
    if (!state.entities[ComplaintSchema.key]) {
        return null;
    }

    const complaints = state.entities[ComplaintSchema.key] as { [id: string]: ComplaintEntity };
    const ids = Object.keys(complaints).filter((key) => {
        return complaints[key].target.id === id && complaints[key].target.schema === entity && !complaints[key].deletedAt;
    });

    return getDenormalizedComplaints(state, ComplaintSchema, ids);
};

export const getComplaintsComplaintsCounts = (entities: EntitiesState, entity: string, ids: number[]) => {
    if (!entities[ComplaintSchema.key]) {
        return null;
    }

    const complaints = entities[ComplaintSchema.key] as { [id: string]: ComplaintEntity };
    const filteredComplaints = Object.keys(complaints).filter((key) => {
        return complaints[key].target.schema === entity && ids.includes(complaints[key].target.id) && !complaints[key].deletedAt;
    });

    return filteredComplaints.length;
};
